<ion-item lines="none" class="primary" detail="false" pointer>
  <ion-icon slot="end" color="primary" name="arrow-forward"></ion-icon>
  <ion-label>
    <h2 class="text-primary-dark"> {{ title }} </h2>
    <h3 class="text-primary-dark" padding-top-half>
      <ion-icon
        [color]="pendencies === 0 ? 'success' : 'danger'"
        [name]="pendencies === 0 ? 'ios-checkmark-circle-outline' : 'md-alert'"
      ></ion-icon>
      {{ subtitle }}
    </h3>
  </ion-label>
</ion-item>
<div class="divider"></div>
